import { Component, OnInit, Injectable, Input  } from '@angular/core';

import { DefaultEditor, ViewCell } from 'ng2-smart-table';

import { DateTimeAdapter, OwlDateTimeIntl } from 'ng-pick-datetime';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'controlHoras-xxxxxxRevisor',
  templateUrl: './customInputDate.component.html',
  styleUrls: ['./customInputDate.component.scss']
})
export class CustomInputDate extends DefaultEditor implements OnInit {
  @Input() placeholder: string = 'Elige una hora';
constructor(private datePipe: DatePipe) {
  super();
  

 }

 inputModel: Date ;
 controlDisabled : boolean=false;
  ngOnInit() {
    if(this.cell.newValue && this.cell.newValue != "-") {
      this.inputModel = new Date(this.cell.newValue);
    }else{
        this.controlDisabled = true;
    }
  }
  onChange(event) {
    if(event) {
      this.cell.newValue = event;
    }
  }

}

@Component({
  template: `{{value | date:'short'}}`,
})
export class CustomInputDateRenderComponent implements ViewCell, OnInit {
  @Input() value: string;
  @Input() rowData: any;

  constructor() { }

  ngOnInit() { }

}